import { render, staticRenderFns } from "./SupplierLayout.vue?vue&type=template&id=295112a3&"
import script from "./SupplierLayout.vue?vue&type=script&lang=js&"
export * from "./SupplierLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports